<template>
	<Layout :loading="loading" :pageTitle="'Dashboard'">
		<template #breadcrumb>
			<router-link tag="li" to="/" class="breadcrumb-item active"><i class="icon icon-home-1"></i></router-link>
		</template>

		<!-- <template #cta>
		<router-link tag="a" :to="`${$route.path}/create`" class="btn btn-success">Crear categoría</router-link>
	</template> -->

		<div class="main-container container-fluid">
			<div class="call-container" v-if="currentCall && currentCall.id">
				<Calling />
			</div>
			<div v-else>
				<div class="container">
					<div class="row">
						<div class="col">
							<div class="mt-4 p-3">
								<h4>Historial de llamadas</h4>
								<div>
									<div class="card mt-2">
										<div class="card-body">
											<table class="table table-clickeable">
												<tr class="table-head">
													<td>Fecha</td>
													<td>Cliente</td>
													<td>Email</td>
													<td>Duración</td>
												</tr>

												<tr v-for="item of list" :key="item.id">
													<td>
														<div class="d-flex align-items-center">
															{{ item.createdAt | moment("DD-MM-YYYY HH:mm") }}
														</div>
													</td>
													<td>
														<div class="d-flex align-items-center">
															<span v-if="item.client && item.client.name"
																>{{ item.client.name }} {{ item.client.lastname }}</span
															>
															<span v-else>Invitado</span>
														</div>
													</td>
													<td>
														<div class="d-flex align-items-center">
															<span v-if="item.client && item.client.email">{{
																item.client.email
															}}</span>
															<span v-else>---</span>
														</div>
													</td>
													<td>
														<div class="d-flex align-items-center">
															{{ item.duration }} minutos
														</div>
													</td>
												</tr>
											</table>

											<div class="alert alert-info text-center" v-if="list.length == 0">
												No se han encontrado llamadas
											</div>

											<Pagination :pageData="pagination" @pageChange="pageChange" />
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</Layout>
</template>

<script>
import Calling from "@/components/Calling"
import listMixins from "@/mixins/listMixins"
import gql from "graphql-tag"

export default {
	name: "dashboard",
	components: {
		Calling
	},
	data() {
		return {
			loading: false,
			list: []
		}
	},
	computed: {
		currentCall: function() {
			return this.$store.getters.currentCall
		}
	},
	beforeMount() {
		this.filters = this.getValidUrlParams()
		this.load()
	},
	methods: {
		load() {
			this.$apollo
				.query({
					query: gql`
						query($take: Int, $skip: Int) {
							calls(take: $take, skip: $skip) {
								data {
									id
									code
									client {
										id
										name
										email
									}
									status
									statusText
									statusClass
									createdAt
									duration
								}
								pageInfo {
									totalItems
								}
							}
						}
					`,
					variables: {
						take: this.pagination.length,
						skip: this.pagination.skip
					},
					fetchPolicy: "no-cache"
				})
				.then((data) => {
					this.list = data.data.calls.data
					this.pagination.pageInfo = data.data.calls.pageInfo
					this.loading = false
				})
		}
	}
}
</script>

<style scoped lang="scss">
.call-container {
	position: absolute;
	top: 0px;
	right: 0px;
	width: calc(100% - 300px);
	height: 100%;
	background-color: #f1f1f1;
}
</style>
